// Pricing benchmark: Edward's entry plan is $39/mo. Rankr is priced at 2x.
// Annual: Edward's assumed annual saving is 50%; Rankr gives 80% of that (40% off).
export const RANKR_MONTHLY = 78;
export const RANKR_ANNUAL_DISCOUNT = 0.4;
export const RANKR_ANNUAL_MONTHLY = RANKR_MONTHLY * (1 - RANKR_ANNUAL_DISCOUNT);

export const RANKR_STEPS = [
  { title: 'Share your website', body: 'Send us your link. Our engineers connect your site — WordPress, Shopify, Wix, Webflow and 100+ platforms — so you never touch a setting.' },
  { title: 'Get your 90-day growth plan', body: 'We map the keywords, pages and technical fixes with the highest upside for your market and competitors.' },
  { title: 'Review or auto-approve', body: 'Stay in control of every page, or let our team handle the routine work end to end.' },
  { title: 'Grow while you sleep', body: 'Fresh, on-brand content goes live daily. Your rankings on Google and ChatGPT keep climbing.' },
];

export const RANKR_FEATURES = [
  { icon: 'PenLine', title: 'Daily expert content', body: 'Service pages, location pages, guides, FAQs and comparisons written in your brand voice.' },
  { icon: 'Wrench', title: 'Technical SEO fixed', body: 'Meta tags, titles, broken links, schema and page speed — fixed quietly in the background.' },
  { icon: 'Search', title: 'Keywords that buy', body: 'We target the exact terms your customers search right before they call, book or buy.' },
  { icon: 'Bot', title: 'Visible in AI answers', body: 'Every page is structured to be cited by ChatGPT, Perplexity and Google AI Overviews.' },
  { icon: 'Link2', title: 'Smart internal linking', body: 'Pages connected so Google understands your site and visitors move toward your offer.' },
  { icon: 'Users', title: 'Real engineers, not a login', body: 'A dedicated specialist sets up, monitors and improves your account. No learning curve, ever.' },
  { icon: 'Globe', title: 'Multi-language publishing', body: 'Reach new markets with localised pages, without hiring translators.' },
  { icon: 'BarChart3', title: 'Monthly growth report', body: 'Clicks, rankings and leads explained in plain English by your specialist.' },
];

export const RANKR_INCLUDED = [
  'Done-for-you setup by a real engineer',
  '90-day SEO & AI-search roadmap',
  'Daily on-brand content publishing',
  'Weekly technical SEO audits & fixes',
  'Competitor & keyword research',
  'On-brand image generation',
  'Google, ChatGPT & AI Overviews optimisation',
  'Dedicated growth specialist',
  'Monthly plain-English performance report',
  'Priority support, 7 days a week',
];

export const RANKR_FAQS = [
  { q: 'How is Rankr different from an SEO tool?', a: 'Tools give you a dashboard and leave the work to you. With Rankr, real engineers set everything up, run it daily and report back. You do not need any technical knowledge.' },
  { q: 'What is the 90-day guarantee?', a: 'If you are not satisfied within your first 90 days, tell us and we refund your subscription in full. No hoops, no partial credits.' },
  { q: 'Which website platforms do you support?', a: 'WordPress, Shopify, Wix, Squarespace, Webflow, GoDaddy, HubSpot, Framer and 100+ more. If your site is custom, our engineers will connect it for you.' },
  { q: 'How soon will I see results?', a: 'Technical fixes go live in the first week. Most clients see rankings and traffic climb within 60–120 days as new pages are indexed.' },
  { q: 'Can I cancel anytime?', a: 'Yes. Monthly plans cancel at the end of the billing period. Annual plans are covered by the same 90-day money-back guarantee.' },
];